import { ShareTo } from "../../config/Enums";
import { IShareSocialMediaItem } from "../../models/Interfaces";
import FacebookPublishingProvider from "./FacebookPublishingProvider";
import TwitterPublishingProvider from "./TwitterPublishingProvider";
import { ISocialPublishResult, ISocialPublishingProvider } from "./types";

export class SocialPublishingService {
  private readonly providers: Map<ShareTo, ISocialPublishingProvider>;

  constructor() {
    const facebookProvider = new FacebookPublishingProvider();
    const twitterProvider = new TwitterPublishingProvider();

    this.providers = new Map<ShareTo, ISocialPublishingProvider>([
      [ShareTo.Facebook, facebookProvider],
      [ShareTo.X, twitterProvider]
    ]);
  }

  public getProvider(platform: ShareTo): ISocialPublishingProvider | null {
    return this.providers.get(platform) ?? null;
  }

  public async shareVersionContent(sharedItem: IShareSocialMediaItem, platform: ShareTo): Promise<ISocialPublishResult> {
    const provider = this.getProvider(platform);
    if (!provider) {
      return { status: "failed" };
    }

    return provider.sharePost(sharedItem);
  }
}
